import { render } from "./LeavePeriodDropdown.vue?vue&type=template&id=3a4d64f8"
import script from "./LeavePeriodDropdown.vue?vue&type=script&lang=js"
export * from "./LeavePeriodDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__